export default __webpack_public_path__ + "static/media/Bg6.3f307e61.png";